import { InjectionToken } from '@angular/core';

export type BooxApplicationToken = {
    call_sign : string;
    name : string;
    [key: string]: any;
}


export const BOOX_APPLICATION_HOST = new InjectionToken<BooxApplicationToken | null>('(lib-boox) BOOX_APPLICATION_HOST',{
    providedIn : 'root', factory: () => null
});
export const BOOX_APPLICATION_GUEST = new InjectionToken<BooxApplicationToken | null>('(lib-boox) BOOX_APPLICATION_GUEST',{
    providedIn : 'root', factory: () => null
});